import apiClient from './authService';

export function viewMe() {
  return apiClient
    .get('/auth/me/')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Failed to fetch user data');
      }

      throw new Error('Network error');
    });
}